import { render } from "./TranslateExperience.vue?vue&type=template&id=fcba36ac"
import script from "./TranslateExperience.vue?vue&type=script&lang=js"
export * from "./TranslateExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__